import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TagComponent } from './tag.component';
import { TextModule } from '../../ui/text/text.module';

@NgModule({
  declarations: [TagComponent],
  imports: [CommonModule, TextModule],
  exports: [TagComponent],
})
export class TagModule {}
